var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { FlatSheetProduct } from "@rendering/vortex-paper-products";
import { loadFinishMap, loadSubstrateMap } from "./materialLoader";
export function getFlatSheetProduct(productConfig) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    const {
      surfaceMapping
    } = productConfig;
    // Validate the surface mapping
    if (!surfaceMapping.front || !surfaceMapping.body || !surfaceMapping.back) {
      throw new Error("The FlatSheetProductConfig must contain three surfaces for front, body, and back!");
    }
    // Load substrate and finish maps
    const substrateMap = yield loadSubstrateMap(productConfig);
    const finishMap = yield loadFinishMap(productConfig);
    // Get substrateIds for each surface
    const frontSubstrateId = surfaceMapping.front.substrateId;
    const bodySubstrateId = surfaceMapping.body.substrateId;
    const backSubstrateId = surfaceMapping.back.substrateId;
    // Get finishes if they exist
    const finishes = {
      front: [],
      back: []
    };
    if (productConfig.finishUrlMap && surfaceMapping.front.finishIds) {
      for (let i = 0; i < surfaceMapping.front.finishIds.length; i++) {
        const finishId = surfaceMapping.front.finishIds[i];
        finishes.front.push(finishMap[finishId]);
      }
    }
    if (productConfig.finishUrlMap && surfaceMapping.back.finishIds) {
      for (let i = 0; i < surfaceMapping.back.finishIds.length; i++) {
        const finishId = surfaceMapping.back.finishIds[i];
        finishes.back.push(finishMap[finishId]);
      }
    }
    const response = yield fetch(productConfig.productDataUrl);
    if (!response.ok) {
      if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("application/json")) {
        const data = yield response.json();
        throw new Error("Failed to fetch FlatSheetData from '".concat(productConfig.productDataUrl, "': ").concat(JSON.stringify(data), "}"));
      }
      throw new Error("Failed to fetch FlatSheetData from '".concat(productConfig.productDataUrl, "'!"));
    }
    const flatSheetData = yield response.json();
    const flatSheetConfig = {
      substrates: [substrateMap[frontSubstrateId], substrateMap[bodySubstrateId], substrateMap[backSubstrateId]],
      pageMapping: {
        front: surfaceMapping.front.page,
        back: surfaceMapping.back.page
      },
      finishes,
      fullBleed: flatSheetData.fullBleed,
      trim: flatSheetData.trim,
      depth: flatSheetData.thickness,
      orientation: flatSheetData.orientation,
      customPath: flatSheetData.customPath
    };
    return new FlatSheetProduct(flatSheetConfig);
  });
}